import * as pdfjsLib from 'pdfjs-dist';

// pdf.js uses Promise.try (ES2025) when handling worker requests, e.g. asking for a password.
// zone.js replaces the global Promise with ZoneAwarePromise, which does not have it.
if (typeof (Promise as any).try !== 'function') {
  (Promise as any).try = function <T>(this: PromiseConstructor, fn: (...args: any[]) => T | PromiseLike<T>, ...args: any[]): Promise<T> {
    return new this<T>(resolve => resolve(fn(...args)));
  };
}

// Definir manualmente a URL do worker (sem import dinâmico)
const pdfWorkerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.mjs`;

(pdfjsLib as any).GlobalWorkerOptions.workerSrc = pdfWorkerSrc;

export default pdfjsLib;
